import axios from 'axios'

export const postFeedback = async feedback => {
  const {data} = await axios.post(`/feedback`, feedback)
  return data
}
